export default __webpack_public_path__ + "static/media/binance.dfc82362.svg";